import {
	RavenActionBar,
	RavenCopyText,
	RavenInputField,
	RavenModal,
	RavenTextTrim,
	RavenValidateData,
} from '@ravenpay/raven-bank-ui';
import React, { useEffect, useState } from 'react';
import {
	capitalizeAllLetter,
	hasDifference,
	reactSelectStyle,
	removeSpace,
} from '../../../../../utils/helper/Helper';
import { areEqual, isTrulyEmpty } from '../../../../../utils/helper/helperTwo';
import { businessCategories } from '../../data/businessCategory';
import { bankboxAPI } from '../../../../../redux/bankbox';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../redux/types';
import NoContentBox from '../../components/no-content/NoContentBox';

interface MyComponentProps {
	onClose?: () => void;
	onPersonalEdit?: () => void;
	visible?: boolean;
	onBusinessEdit?: () => void;
	fromPersonal?: boolean;
	detail?: any;
	onEdit?: () => void;
}

const BusinessRequestChangeModal = ({
	onClose,
	onBusinessEdit,
	onPersonalEdit,
	visible,
	fromPersonal,
	detail,
	onEdit,
}: MyComponentProps) => {
	const [step, setStep] = useState(1);
	const stepList = [1, 2];
	const { user_merchant, user_merchant_settlement, loading } = useSelector(
		(state: RootState) => state.bankbox
	);
	const dispatch = useDispatch();

	const handleClose = () => {
		onClose && onClose();
	};

	const detailsList = [
		{
			type: 'OLD BUSINESS DETAILS',
			business_name: user_merchant?.business_update?.old_business_name || '',
			business_email:
				user_merchant?.business_update?.email ||
				user_merchant?.user?.poseidon_email ||
				'',
			// category: user_merchant?.user?.business_category || '',
			// address: user_merchant?.user?.poseidon_business_address || '',
		},
		{
			type: 'NEW BUSINESS DETAILS',
			business_name: user_merchant?.business_update?.new_business_name || '',
			business_email:
				user_merchant?.business_update?.email ||
				user_merchant?.user?.poseidon_email ||
				'',
			// category: user_merchant?.user?.business_category || '',
			// address: user_merchant?.user?.poseidon_business_address || '',
		},
	];

	const noteIcon = (
		<svg
			className="img"
			width="21"
			height="21"
			viewBox="0 0 21 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.464 20.0163C15.7399 20.0163 20.0168 15.7394 20.0168 10.4635C20.0168 5.1876 15.7399 0.910645 10.464 0.910645C5.18809 0.910645 0.911133 5.1876 0.911133 10.4635C0.911133 15.7394 5.18809 20.0163 10.464 20.0163Z"
				fill="#EA872D"
			/>
			<path
				d="M10.464 6.64235V10.4635M10.464 14.2846H10.4735M20.0168 10.4635C20.0168 15.7394 15.7399 20.0163 10.464 20.0163C5.18809 20.0163 0.911133 15.7394 0.911133 10.4635C0.911133 5.1876 5.18809 0.910645 10.464 0.910645C15.7399 0.910645 20.0168 5.1876 20.0168 10.4635Z"
				stroke="#FFF6ED"
				strokeWidth="1.43293"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	const trimNum = 22;

	return (
		<>
			<RavenModal
				onClose={handleClose}
				visble={visible}
				onBtnClick={() => {}}
				btnColor="deep-green-light"
				// btnLabel={step === 1 ? `Proceed` : `Send Change Request`}
				className={`session-expired-wrap-modal`}
				// disabled={handleDisable()}
				loading={loading}
				// disabled={formData?.business_name === detail?.poseidon_business_name}
			>
				<div
					// onClick={() => {
					// 	console.log(user_merchant);
					// }}
					className="assign-bb-modal edit-user-merchant-detail-modal-wrap-box"
					// style={{ paddingBottom: '5rem' }}
				>
					<div className="assign-bb-modal__title">
						<h6>Business Details Change</h6>
						<p>{`Request to change business details.`}</p>
					</div>
					{/* changes box wrapper start */}
					<div className="changes-box-wrap-old-new grey-bg">
						<>
							{loading ? (
								<div
									style={{
										height: '35rem',
										display: 'grid',
										placeItems: 'center',
									}}
								>
									<NoContentBox loading={true} />
								</div>
							) : (
								<>
									{detailsList?.map((chi, idx) => {
										return (
											<div key={idx} className="view-box">
												<p className="type-name grey-white-color">
													{chi?.type}
												</p>
												<div className="content-box white-black-bg">
													{/* label value box start */}
													<div className="label-value-box border-theme-bottom">
														<p className="label grey-white-color">
															Business Name
														</p>
														<p className="value black-white-color">
															<RavenCopyText
																text={chi?.business_name}
																stopPropagation
																trimNum={trimNum}
																color="deep-green-light"
																copyIconColor="var(--primary-base-color)"
																copyIconBgColor="var(--primary-accent-color-one)"
																copiedBgColor=" var(--primary-base-color)"
															/>
															{/* {RavenTextTrim(chi?.business_name, trimNum)} */}
														</p>
													</div>
													{/* label value box end */}
													{/* label value box start */}
													<div className="label-value-box border-theme-bottom">
														<p className="label grey-white-color">
															Business Email
														</p>
														<p className="value black-white-color">
															{RavenTextTrim(chi?.business_email, trimNum)}
														</p>
													</div>
													{/* label value box end */}

													{/* label value box start */}
													{/* <div className="label-value-box border-theme-bottom">
											<p className="label grey-white-color">Category</p>
											<p className="value black-white-color">
												{RavenTextTrim(chi?.category, trimNum)}
											</p>
										</div> */}
													{/* label value box end */}
													{/* label value box start */}
													{/* <div className="label-value-box border-theme-bottom">
											<p className="label grey-white-color">Address</p>
											<p className="value black-white-color">
												{RavenTextTrim(chi?.address, trimNum)}
											</p>
										</div> */}
													{/* label value box end */}
												</div>
											</div>
										);
									})}
								</>
							)}
						</>
					</div>
					{/* changes box wrapper end */}
					{!loading ? (
						<div className="">
							<RavenActionBar
								className="action-box"
								type={
									String(user_merchant?.business_update?.status) === '0'
										? 'warning'
										: 'error'
								}
								visible={true}
								msg={
									String(user_merchant?.business_update?.status) === '0'
										? 'Request Pending'
										: 'Request Rejected'
								}
								actionText="Edit Request"
								onAction={onEdit}
							/>

							{String(user_merchant?.business_update?.status) === '2' ? (
								<div className="capture-note-box grey-bg-two">
									<div className="img-note">
										<figure className="img-box">{noteIcon}</figure>
									</div>
									<p className="note grey-white-color">{`Rejected note: ${
										user_merchant?.business_update?.review_notes || ''
									}`}</p>
								</div>
							) : (
								''
							)}
						</div>
					) : (
						''
					)}
				</div>
			</RavenModal>
		</>
	);
};

export default BusinessRequestChangeModal;
